import { useSelector } from 'react-redux'

// Selectors
import { selectUserSongWithSongs } from 'modules/usersongs/selectors'

// Types
import type { State, EntityState, PRO, UserSong } from 'types'

// Utils
import { COUNTRIES } from '@constants'

export const usePROList = (): Array<{ id: string; label: string }> => {
  const PROs = useSelector<State, EntityState<PRO>>(state => state.entities.pros)
  return Object.values(PROs)
    .sort((a, b) => {
      if (a.name === 'N/A') {
        return -1
      } else if (b.name === 'N/A') {
        return 1
      }
      return a.country.localeCompare(b.country)
    })
    .map(({ name, country }) => {
      const countryObj = COUNTRIES[country]
      const id = `${countryObj ? `(${countryObj.country_name}) ` : ''}${name}`
      return {
        id,
        label: id,
      }
    })
}

export const useUserSongWithSongs = (userSongId: number): UserSong | null => {
  return useSelector<State, UserSong | null>(state => selectUserSongWithSongs(state, userSongId))
}
